/**
 * ============================================================
 * Mining Survey WebGIS
 * Waypoint Module
 * ============================================================
 */

import AppState from "../core/app.js";
import Map from "./map.js";
import UI from "./ui.js";

class Waypoint {
    /**
     * Reset semua waypoint
     */
    reset() {
        AppState.waypoints = [];

        Map.clearWaypoints();
    }

    /**
     * Tambah waypoint baru
     */
    add(position, name, description = "") {
        // GPS harus tersedia
        if (!position) {
            alert("GPS belum tersedia.");

            return false;
        }

        // Validasi nama
        if (!name || !name.trim()) {
            alert("Waypoint Name wajib diisi.");

            return false;
        }

        const waypoint = {
            id: crypto.randomUUID(),

            feature: "waypoint",

            name: name.trim(),

            description: description.trim(),

            latitude: position.latitude,

            longitude: position.longitude,

            altitude: position.altitude,

            accuracy: position.accuracy,

            heading: position.heading,

            speed: position.speed,

            timestamp: new Date(position.timestamp).toISOString(),

            marker: null,
        };

        // Simpan waypoint
        AppState.waypoints.push(waypoint);
        UI.enableSaveButton(true);

        // Tambahkan marker
        Map.addWaypointMarker(waypoint);

        console.log("📌 Waypoint Added");

        console.table(waypoint);

        console.log(`Total Waypoint : ${AppState.waypoints.length}`);
        return true;
    }

    /**
     * Hapus waypoint berdasarkan ID
     */
    remove(id) {
        const index = AppState.waypoints.findIndex((wp) => wp.id === id);

        if (index === -1) return;

        const waypoint = AppState.waypoints[index];

        if (waypoint.marker) {
            Map.waypointLayer.removeLayer(waypoint.marker);
        }

        AppState.waypoints.splice(index, 1);

        console.log("🗑 Waypoint Removed");
    }

    /**
     * Semua waypoint
     */
    getAll() {
        return AppState.waypoints;
    }

    /**
     * Jumlah waypoint
     */
    getCount() {
        return AppState.waypoints.length;
    }
}

export default new Waypoint();
